import React from 'react';
import RestaurantReserveTemplate from '../../components_membership_hotel/template/esthetic/restaurantReserveTemplate';
import { getReserveList, getVacancyCalendarRstEsthe } from '../../const';
import image_base from '../../resources/image/HakoneGardenTerrace.jpg';
import common from "../../resources/js/common/common";

class restaurantReserve extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // 予約確認モーダル
            membershipPopup: false,
            popupData: {},
            popupDataList: [],
            popupMessage: "",
            popupMode: "",
            popupTitle: "",
            locationInfo: props.location.state && props.location.state.locationInfo ? props.location.state.locationInfo : false,
            // popupSelectedData: {
            //     riyoDate: null,
            //     peopleNum: null,
            //     mealTime: { jikantai: null, time: null },
            //     course: [],

            // }
            // // 選択した値
            // peopleNum: null,
            // mealTime: null,
            // course: null,
            calendarFlg: false,
            vacancyItems: [],
            importedFlg: true,
            changeFlg: false,
            // コース詳細モーダル
            coursePopup: false,
            courseData: {},
        };
    };

    render() {
        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            },
        }

        // お客様情報入力画面モーダル表示
        const onClickOpenPopupWindow = (mode, restaurantInfo, restaurantReserveInfo) => {

            this.setState({ membershipPopup: true });
            if (mode) {
                if (mode == "yoyakuTime") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "時間選択",
                    });
                } else if (mode == "course") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "コース選択",
                    });
                } else if (mode == "people") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "利用人数",
                        popupData: {
                            courseList: [
                                { courseName: "ご利用人数" },
                            ]
                        }
                    });
                } else if (mode == "doiInfo") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "",
                    });
                } else if (mode == "serviceInfo") {
                    this.setState({
                        popupMode: mode,
                        popupTitle: "",
                    });
                }

            }

        }

        // popupData変更
        const setPopupData = (data) => this.setState({ popupData: data })

        // コース詳細ポップアップ表示
        const onClickOpenCoursePopup = (course) => {
            this.setState({
                coursePopup: true,
                courseData: course,
            });
        }

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (pointKaiinId) => {
            this.setState({ membershipReservationConfPopup: true });
            common.doPost(getReserveList, { pointKaiinId: pointKaiinId, importedFlg: true }, afterGetReserveList);
        }

        // 予約情報取得後処理
        const afterGetReserveList = (res) => {
            let data = res.data;
            if (data.resultCode == 0) {
                this.setState({ reservationConfList: res.data, });
            }
        }

         // カレンダー空き情報取得後処理
         const afterGetVacancyRestaurant = (res) => {
            if (res.data.resultCode == '0') {
                this.setState({ vacancyItems: res.data.dateList, calendarFlg: true });
            }
        }

        // 利用日カレンダーモーダル
        const onClickOpenCalendarWindow = (reqRestaurantInfo, reqReserveInfo) => {
            let reqCourseList = [];
            if (reqReserveInfo.courseList?.length > 0) {
                reqCourseList = reqReserveInfo.courseList.map(value => {
                    return {courseCd: value.courseCd};
                });
            }
            const param = {
                honkanShisetsuCd: reqRestaurantInfo.honkanShisetsuCd,
                shisetsuCd: reqRestaurantInfo.shisetsuCd,
                cornerBunKbn: "1",
                rstEstheCd: reqRestaurantInfo.restaurantCd,
                startDate: reqReserveInfo.riyoDate,
                riyoNinzu: reqReserveInfo.peopleNum ? reqReserveInfo.peopleNum : 2,
                courseList: reqCourseList,
                jikantai: reqReserveInfo.jikantai
            }
            // カレンダー空き情報取得
            common.doPost(getVacancyCalendarRstEsthe, param, afterGetVacancyRestaurant);
        }

        // 予約確認モーダルを閉じる
        const onClickCloseReservationConfPopupWindow = () => { this.setState({ membershipReservationConfPopup: false }); };

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ membershipPopup: false }); };

        // コース詳細モーダルClose
        const onClickCloseCoursePopup = () => { this.setState({ coursePopup: false }); };

        // popupMode変更
        const setPopupMode = (mode) => this.setState({ popupMode: mode })

        // popUpMessage変更
        const setPopupMessage = (message) => this.setState({ popupMessage: message })

        // 利用日選択カレンダーポップアップ表示制御用フラグ設定
        const setCalendarFlg = (calendarFlg) => this.setState({ calendarFlg: calendarFlg });

        // 戻るボタン遷移先判定用フラグ設定
        const setChangeFlg = (changeFlg) => this.setState({ changeFlg: changeFlg });

        return (
            <div style={style.base}>
                <RestaurantReserveTemplate
                    state={this.state}
                    onClickOpenPopupWindow={onClickOpenPopupWindow}
                    onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickCloseReservationConfPopupWindow={onClickCloseReservationConfPopupWindow}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    onClickOpenCoursePopup={onClickOpenCoursePopup}
                    onClickCloseCoursePopup={onClickCloseCoursePopup}
                    setPopupMode={setPopupMode}
                    setPopupMessage={setPopupMessage}
                    setPopupData={setPopupData}
                    setCalendarFlg={setCalendarFlg}
                    setChangeFlg={setChangeFlg}
                />
            </div>
        )
    }
}

// function sleep(ms) {
//     return new Promise(resolve => setTimeout(resolve, ms));
// }

export default restaurantReserve;